import React, { Component } from "react";
import AUX from "../../../hoc/Aux_";
import AuthService from "../../Auth/AuthService";
import { Modal, Card, Accordion, Button } from "react-bootstrap";
import $ from "jquery";
import arrayMove from "array-move";
import SortableComponent from "../../AdvanceSearch/SavedSearches/SortableComponent";
import { toast } from "react-toastify";
import FacilityColumnsService from "./FacilityColumnsService";

class FacilityCustomizeResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: this.props.showModal,
      availableFields: [],
      categoryFields: [],
      selectedFields: [],
      memberId: AuthService.getProfile().memberData.id,
      selectedFieldsCount: 0,
      requiresResultRefresh: false,
      isLoading: false,
    };

    this.showSpinner = this.showSpinner.bind(this);
    this.hideSpinner = this.hideSpinner.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.showModal !== prevProps.showModal) {
      this.setState({
        showModal: this.props.showModal,
      });
    }
    this.updateCounts();
  }

  updateCounts = () => {
    let headers = $("div[data-header-id]");
    $(headers).each(function (index, category) {
      var totalFields = $(category).find(".available-field");
      var hiddenFields = $(category).find(".available-field.hidden");
      var visibleFields = $(totalFields).length - $(hiddenFields).length;
      $(category)
        .find(".card-header")
        .find(".field-summary")
        .html(`${visibleFields}/${$(totalFields).length}`);
    });
  };

  handleClose = () => {
    this.props.customizeDialogClosed(
      this.state.requiresResultRefresh,
      this.state.selectedFields
    );
    this.setState({
      availableFields: [],
      selectedFields: [],
      categoryFields: [],
      showModal: false,
      requiresResultRefresh: false,
    });
  };

  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };

  loadColumnCategories = async () => {
    this.setState({
      availableFields: [],
      selectedFields: [],
      categoryFields: [],
      isLoading: true,
    });
    this.showSpinner();

    try {
      let selectedFields = this.props.selectedFields || [];
      const response = await FacilityColumnsService.GetColumnCategories(
        this.state.memberId,
        selectedFields
      );

      if (response) {
        // Filter columns based on user permissions
        const filteredAvailable = response.availableFields.map((category) => {
          return {
            ...category,
            facilityColumns: category.facilityColumns
              ? category.facilityColumns.filter((col) =>
                  AuthService.canView(col.permissionFeatureId)
                )
              : [],
          };
        });

        const filteredSelected = response.selectedFields
          ? response.selectedFields.filter((col) =>
              AuthService.canView(col.permissionFeatureId)
            )
          : [];

        this.setState({
          availableFields: filteredAvailable,
          selectedFields: filteredSelected,
          selectedFieldsCount: filteredSelected.length,
        });

        // Flatten all columns for lookup
        let fields = [];
        filteredAvailable.forEach((category) => {
          if (category.facilityColumns) {
            fields = [...fields, ...category.facilityColumns];
          }
        });
        this.setState({
          categoryFields: [...fields],
        });
      }
    } catch (error) {
      toast.error("Error loading column categories");
    }

    this.setState({ isLoading: false });
    this.hideSpinner();
  };

  showHide(fldId) {
    let { selectedFields } = this.state;
    var existing = selectedFields.filter((fld) => {
      return fld.id === fldId;
    });
    if (existing.length > 0) {
      return " hidden";
    } else {
      return "";
    }
  }

  moveToSelected = (fieldId) => {
    let available = [...this.state.categoryFields];
    let filteredItem = available.filter((fld) => {
      return fld.id === fieldId;
    });
    let fieldToMove = filteredItem[0];
    let selectedFields = [...this.state.selectedFields];
    selectedFields.push(fieldToMove);
    this.setState({
      selectedFields: selectedFields,
      selectedFieldsCount: selectedFields.length,
    });
  };

  renderAvailableFields = (availableFields) => {
    if (!availableFields || availableFields.length === 0) {
      return <div className="text-center p-3">No columns available</div>;
    }

    return (
      <Accordion className="available-fields-container">
        {availableFields.map((header, idx) => {
          if (
            !header.facilityColumns ||
            header.facilityColumns.length === 0
          ) {
            return null;
          }

          return (
            <Card data-header-id={header.id} key={idx}>
              <Card.Header className="category-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey={header.id.toString()}
                >
                  {header.categoryName}
                </Accordion.Toggle>
                <span
                  className="field-summary"
                  style={{ float: "right", paddingTop: "6px" }}
                ></span>
              </Card.Header>
              <Accordion.Collapse eventKey={header.id.toString()}>
                <Card.Body>
                  {header.facilityColumns.map((fld, index) => {
                    return (
                      <div
                        className={"available-field" + this.showHide(fld.id)}
                        key={index}
                        data-field-id={fld.id}
                      >
                        {fld.columnName}
                        <i
                          className="fas fa-arrow-right"
                          style={{ float: "right", cursor: "pointer" }}
                          data-field-id={fld.id}
                          title={`Move ${fld.columnName} to selected field(s).`}
                          onClick={() => {
                            this.moveToSelected(fld.id);
                          }}
                          key={index + 1}
                        ></i>
                      </div>
                    );
                  })}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          );
        })}
      </Accordion>
    );
  };

  selectedFieldSorted = (oldIndex, newIndex) => {
    let sortedFields = arrayMove(
      [...this.state.selectedFields],
      oldIndex,
      newIndex
    );
    this.setState({
      selectedFields: sortedFields,
    });
  };

  removeSelectedField = (fieldId) => {
    let selectedFields = [...this.state.selectedFields];
    let filteredItem = selectedFields.filter((fld) => {
      return fld.id === fieldId;
    });
    let fieldToRemove = filteredItem[0];
    const index = selectedFields.indexOf(fieldToRemove);
    if (index > -1) {
      selectedFields.splice(index, 1);
    }
    this.setState({
      selectedFields: selectedFields,
      selectedFieldsCount: selectedFields.length,
    });
  };

  canBeSubmitted = () => {
    return this.state.selectedFieldsCount > 0;
  };

  saveColumnPreferences = async () => {
    this.showSpinner();

    try {
      const columnIds = this.state.selectedFields.map((col) => col.id);
      const columnOrders = this.state.selectedFields.map(
        (col, index) => index + 1
      );

      const success = await FacilityColumnsService.SaveColumnPreferences(
        this.state.memberId,
        columnIds,
        columnOrders
      );

      if (success) {
        // Store in localStorage for quick access
        localStorage.setItem(
          "FacilityColumns_" + this.state.memberId,
          JSON.stringify(this.state.selectedFields)
        );

        this.setState({
          requiresResultRefresh: true,
        });
        this.handleClose();
      }
    } catch (error) {
      toast.error("Error saving column preferences");
    }

    this.hideSpinner();
  };

  resetToDefaults = async () => {
    this.showSpinner();

    try {
      const success = await FacilityColumnsService.ResetColumnPreferences(
        this.state.memberId
      );

      if (success) {
        // Clear localStorage cache
        localStorage.removeItem("FacilityColumns_" + this.state.memberId);

        // Reload defaults from API
        const defaults = await FacilityColumnsService.GetDefaultColumns();
        if (defaults && defaults.length > 0) {
          this.setState({
            selectedFields: defaults,
            selectedFieldsCount: defaults.length,
            requiresResultRefresh: true,
          });

          // Update category counts in Available Fields panel
          this.updateCounts();
        }
      }
    } catch (error) {
      toast.error("Error resetting to defaults");
    }

    this.hideSpinner();
  };

  render() {
    var props = {
      items: [...this.state.selectedFields].map((item) => ({
        ...item,
        permission_feature_id: item.permissionFeatureId,
      })),
      dataKeyField: "id",
      textField: "columnName",
      showDeleteIcon: true,
      onItemDelete: this.removeSelectedField,
    };
    const isEnabled = this.canBeSubmitted();

    return (
      <AUX>
        <Modal
          id="facility-result-customizer-dialog"
          className="result-customizer-dialog"
          show={this.state.showModal}
          onHide={this.handleClose}
          size="lg"
          centered
          onEntered={this.loadColumnCategories}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-center">
              <h5 className="modal-title mt-0">CUSTOMIZE FACILITY COLUMNS</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6 col-sm-12 col-xs-12">
                <Card>
                  <Card.Header className="text-center">
                    Available Field(s)
                  </Card.Header>
                  <Card.Body className="available-fields">
                    {this.state.isLoading ? (
                      <div className="text-center p-3">Loading...</div>
                    ) : (
                      this.renderAvailableFields(this.state.availableFields)
                    )}
                  </Card.Body>
                </Card>
              </div>
              <div className="col-md-6 col-sm-12 col-xs-12">
                <Card>
                  <Card.Header className="text-center">
                    Selected Field(s)
                  </Card.Header>
                  <Card.Body className="sortable-items">
                    <SortableComponent
                      {...props}
                      onSortEnd={(oldIndex, newIndex) =>
                        this.selectedFieldSorted(oldIndex, newIndex)
                      }
                    ></SortableComponent>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="text-center">
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <Button
                variant="warning"
                onClick={this.resetToDefaults}
                title="Reset to default columns"
              >
                Reset to Defaults
              </Button>
              <div>
                <Button variant="secondary" onClick={this.handleClose} style={{ marginRight: "10px" }}>
                  Cancel
                </Button>
                <Button
                  variant="success"
                  disabled={!isEnabled}
                  onClick={this.saveColumnPreferences}
                >
                  Save Changes
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </AUX>
    );
  }
}

export default FacilityCustomizeResults;
